module.exports = __webpack_public_path__ + "static/media/tasklist@2x.bda52cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/tasklist@2x.png
// module id = 748
// module chunks = 0